import React, { FC } from 'react';
import { DeliveryStatus as DeliveryStatusEnum } from '@fdha/graphql-api-patient';
import { SectionType } from '@fdha/common-utils';

import { ReviewDelivery } from '../../../components/delivery';

interface ReviewDeliveryPageProps {
  patientId: string;
  deliveryMenuId: string;
  deliveryId?: string;
  foodProgramUserId?: string;
  status?: DeliveryStatusEnum | null;
  isCanceled?: boolean;
  allowSelfPreparedMeals?: boolean;
  onAddItems?: (itemType: SectionType) => void;
}

export const ReviewDeliveryPage: FC<ReviewDeliveryPageProps> = ({
  patientId,
  deliveryMenuId,
  deliveryId = '',
  foodProgramUserId = '',
  status,
  isCanceled = false,
  allowSelfPreparedMeals = false,
  onAddItems,
}) => {
  return (
    <ReviewDelivery
      deliveryId={deliveryId}
      patientId={patientId}
      foodProgramUserId={foodProgramUserId}
      deliveryMenuId={deliveryMenuId}
      status={status}
      isCanceled={isCanceled}
      allowSelfPreparedMeals={allowSelfPreparedMeals}
      onAddItems={onAddItems}
    />
  );
};

export default ReviewDeliveryPage;
